module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('hydroware-access-to-page-denied', {
    attrs: {
      "text": "Personnel (Tabbed Page)"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e89e4f78"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ICEcontacts/NoPersonnelTabs.vue
// module id = 853
// module chunks = 1